import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { formatDate } from "@utils/DateUtils";
import { ProgressCard } from "@components/ProgressCard/ProgressCard";
import Spinner from "@components/Spinner/Spinner";
import { FormatPattern } from "@enums";
import { useDatePickerContext } from "@contexts/DatePickerContext";
import { useIataContext } from "@contexts/IataContext";
import { useUtcContext } from "@contexts/UtcContext";
import { getBaggageWhiteSide } from "../services";
export const BaggageWhiteSide = () => {
    const { iata } = useIataContext();
    const { picker: { from }, } = useDatePickerContext();
    const { utc } = useUtcContext();
    const { data, isLoading } = useQuery({
        queryFn: () => getBaggageWhiteSide({ iata, date: formatDate(utc, from, FormatPattern.yyyy_MM_dd) }),
        queryKey: ["getBaggeWhiteSide", { iata, from }],
    });
    const { t } = useTranslation();
    if (isLoading)
        return _jsx(Spinner, {});
    return (_jsx(ProgressCard, { variant: "plain", progressVisibility: "hidden", value: (data === null || data === void 0 ? void 0 : data.noBags) || "-", description: t("baggage.widgets.whiteSide.description") }));
};
